<div class="background">

    <app-header></app-header>
    <app-navbar *ngIf="!isMobile"></app-navbar>
    <section>
            <div class="flexLeft" *ngIf="!isMobile">
                <app-settings-card></app-settings-card>
                <app-groups-main class="flexGrow"></app-groups-main>
            </div>
            <div *ngIf="isMobile">
                <app-settings-card
                    *ngIf="!showGroups"
                    (toggleOptionEvent)="toggleOption($event)">
                </app-settings-card>
                <app-groups-main
                    *ngIf="showGroups"
                    (toggleOptionEvent)="toggleOption($event)"
                    class="flexGrow">
                </app-groups-main>
            </div>
    </section>
</div>